import { Alert, Divider, Flex, LabelWrapper, Radio, Select } from "@theorgchartdev/storybook";
import { FieldSelectListProps } from "@/Utils/ComponentLib";
import { PaginationConfig } from "@/appComponents/Blocks/Composites/PaginationConfig/PaginationConfig";
import { TabProps } from "./DocumentExportContent";
import { GetDoc } from "@/Utils/StateLib";
import { appstr } from "@coreapp/utils/appstr";
import { enumSubChartOption } from "@coreapp/constants";
import { QXDoc } from "@coreapp/CoreApp/QXDoc";

type Props = TabProps & {
  sourceDocument: Nullable<QXDoc>;
};

export const DocumentExportPages = (props: Props) => {
  const { sourceDocument } = props;
  const { fieldData, onFieldChange } = props.formController;

  const handleChange = <K extends keyof typeof fieldData>(key: K, value: (typeof fieldData)[K]) => {
    onFieldChange(key, value);
  };

  const fields: string[] = (
    sourceDocument?.GetFieldList2(
      true,
      false,
      false,
      false,
      false,
      true,
      GetDoc()?.GetHierarchyClass()
    ) ?? []
  ).map(item => item.GetFieldName() ?? "");
  const uniqueFields = fields.filter((field, index) => fields.indexOf(field) === index);
  uniqueFields.sort((a, b) => a.localeCompare(b));

  const disablePaginate = fieldData.scope === "Page";
  const disableSort = fieldData.scChartBreakType === enumSubChartOption.nobreak;
  const fieldNames =
    GetDoc()?.GetTargetHeaders(false, false, false, false, [], GetDoc()?.GetHierarchyClass()) ?? [];

  return (
    <Flex direction="column" gap="12px" padding="6px 24px 0">
      <LabelWrapper label={appstr("Pagination wizard")}>
        <PaginationConfig
          handleUpdate={handleChange}
          scConfig={fieldData}
          disabled={disablePaginate}
          showAsIs={!sourceDocument?.IsServerChart()}
          useExportModalStyle
          fieldNames={fieldNames}
        />
      </LabelWrapper>
      <Divider />
      <LabelWrapper label={appstr("Page sort order")}>
        <Flex direction="column" gap="8px">
          <Radio
            disabled={disablePaginate || disableSort}
            id="export-pagination-subchart-sort-preserve"
            label={appstr("Keep order as-is")}
            checked={fieldData.shouldPreserveSubchartSort}
            onChange={() => handleChange("shouldPreserveSubchartSort", true)}
          />
          <Radio
            disabled={disablePaginate || disableSort}
            id="export-pagination-subchart-sort-by-field"
            label={appstr("Sort by field")}
            checked={!fieldData.shouldPreserveSubchartSort}
            onChange={() => handleChange("shouldPreserveSubchartSort", false)}
          />
          <Flex padding={"0 0 0 32px"}>
            <Select
              value={fieldData.scSortKey}
              options={uniqueFields.map(field => ({ label: field, value: field }))}
              selectSize={"medium"}
              listProps={FieldSelectListProps({
                onSelect: option => handleChange("scSortKey", `${option.value}`)
              })}
              disabled={disablePaginate || fieldData.shouldPreserveSubchartSort}
            />
          </Flex>
        </Flex>
      </LabelWrapper>
      {/* <LabelWrapper label={appstr("Box sorting")}>
        <Flex direction="column" gap="6px">
          <Radio
            id="export-pagination-preserve-sort"
            label={appstr("Preserve manaul sort order")}
            checked={fieldData.shouldPreserveSort}
            onChange={() => handleChange("shouldPreserveSort", true)}
          />
          <Radio
            id="export-pagination-automated-sort"
            label={appstr("Automated subchart sorting")}
            checked={!fieldData.shouldPreserveSort}
            onChange={() => handleChange("shouldPreserveSort", false)}
          />
          {!fieldData.shouldPreserveSort && (
            <BoxSort
              preventApply
              manager={fieldData.sortConfig}
              setter={(nextSortConfig: QSortConfig) => handleChange("sortConfig", nextSortConfig)}
            />
          )}
        </Flex>
      </LabelWrapper> */}
      {fieldData.scope === "Page" && (
        <Alert severity={"warning"} withBorder showIcon>
          {appstr("A single page export will not need to re-paginate your chart")}
        </Alert>
      )}
    </Flex>
  );
};
